// fieldDropEligibilityUtils.js
import { FIELD_DROP_ELIGIBILITY_DAYS } from "../constants/appConstants";
import { SELECTED_SO_CODE_NZLO } from "../constants/soCode";
import { getDuration } from "../components/pages/OpenStation/stationUtils";
/**
 * Determines if a child is eligible for field drop popup.
 * Uses the configured threshold from appConstants and SO-specific logic.
 * @param {Object} child - Child object
 * @param {string} soCode - SO code
 * @param {number|string} fdNumberofDays - Number of days for eligibility
 * @returns {boolean} True if eligible, false otherwise
 */
export function isFieldDropEligible(child, soCode, fdNumberofDays, navigateFromAccounts=false) {
  const today = new Date();
  const droppedChildDetails= navigateFromAccounts ? child: child?.droppedChildDetails;
  const sponsorshipEndDateStr = navigateFromAccounts? droppedChildDetails?.sponsorshipEndDate : droppedChildDetails?.childSponsorshipEndDate;
  const isEligibleFlag = child?.isCelebrationEligible;
  const isSensitive = droppedChildDetails?.isSensitive;
  const rflId = navigateFromAccounts ? droppedChildDetails?.rflid : droppedChildDetails?.rflId;

  if (!sponsorshipEndDateStr) return false;
  if (!rflId) return false; // RFLID must not be null

  // Always use fdNumberofDays, fallback to FIELD_DROP_ELIGIBILITY_DAYS if not provided
  const daysToAdd = Number(fdNumberofDays) || FIELD_DROP_ELIGIBILITY_DAYS;
  if (soCode === SELECTED_SO_CODE_NZLO && (isSensitive === "true" || isSensitive === true)) return false;

  const sponsorshipEndDate = new Date(sponsorshipEndDateStr);
  if (isNaN(sponsorshipEndDate)) return false;

  const endDatePlusX = new Date(sponsorshipEndDate);
  endDatePlusX.setDate(endDatePlusX.getDate() + daysToAdd);

  const isEligible = isEligibleFlag === null || isEligibleFlag === "false" || isEligibleFlag === false;

  return today >= sponsorshipEndDate && today <= endDatePlusX && isEligible;
}

export const getFormattedEndDate = (sponsorshipEndDateStr, noOfDays) => {
  const daysToAdd = Number(noOfDays)|| FIELD_DROP_ELIGIBILITY_DAYS;
  const sponsorshipEndDate = new Date(sponsorshipEndDateStr);
  if (isNaN(sponsorshipEndDate)) return null;
  const endDatePlusX = new Date(sponsorshipEndDate);
  endDatePlusX.setDate(endDatePlusX.getDate() + daysToAdd);
  return getDuration(endDatePlusX);
}
